import * as React from 'react';
import FullscreenOutlined from './fullscreen-outlined';
import FullscreenFilled from './fullscreen-filled';
import type { IconCombinedProps } from './types';
const FullscreenCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <FullscreenFilled ref={ref} {...rest} />;
  }
  return <FullscreenOutlined ref={ref} {...rest} />;
});
export default FullscreenCombined;